<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 240px">
        <p>供应商：</p>
        <el-input v-model="taskIpt" size="mini" style="width: 150px" placeholder="请输入供应商" />
      </div>
      <div class="navContainer" style="width: 240px">
        <p>船舶名称：</p>
        <el-input v-model="shipIpt" size="mini" style="width: 150px" placeholder="请输入船舶名称" />
      </div>
      <div class="navContainer" style="width: 240px">
        <p>航次：</p>
        <el-input v-model="voyageIpt" size="mini" style="width: 150px" placeholder="请输入航次" />
      </div>
      <div class="navContainer" style="width: 240px">
        <p>状态：</p>
        <el-select v-model="state" style="width: 150px" size="mini" filterable clearable placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.val" :label="item.name" :value="item.val"></el-option>
        </el-select>
      </div>
      <div class="navContainer" style="width: 320px">
        <p>预计到港时间：</p>
        <el-date-picker v-model="startTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange1" type="date" placeholder="开始日期" />
        <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-model="endTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange1" type="date" placeholder="结束日期" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <!-- <el-button size="small" type="primary">一键装车</el-button> -->
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }">
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{ scope.$index + 1 }}</div>
          </el-table-column>
          <!-- <el-table-column prop="taskNumber" label="任务编号" min-width="160" align="center"/> -->
          <el-table-column prop="supplierName" label="供应商名称" min-width="150" align="center" />
          <el-table-column prop="shipName" label="船舶名称" align="center" />
          <el-table-column prop="voyageNumber" label="航次编号" align="center" />
          <el-table-column prop="startPortName" label="起始港" align="center" />
          <el-table-column prop="deliveryPortName" label="到达港" min-width="120" align="center" />
          <el-table-column prop="loadingNum" label="预装车数量" min-width="120" :formatter="convert0" align="center" />
          <el-table-column prop="leftoverNum" label="实际装车数量" min-width="120" :formatter="convert0" align="center" />
          <el-table-column prop="unloadedNumber" label="实际卸车数量" min-width="120" :formatter="convert0" align="center" />
          <el-table-column label="实际未卸车数量" min-width="120" :formatter="convert1" align="center"> </el-table-column>
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{ getShipState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="操作" width="250" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情 </el-button>
                <el-button v-if="scope.row.status === 0" size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改 </el-button>
                <el-button v-if="scope.row.status === 1" size="mini" type="primary" @click="openPort(scope.row)" class="yellow-bg">添加港口 </el-button>
                <el-button v-if="scope.row.status === 1" size="mini" type="primary" @click="deployClick(scope.row)">调配完成 </el-button>
                <!-- <el-button v-if="scope.row.status===1" size="mini" type="primary" @click="changeRouteClick(scope.$index, scope.row)" class="yellow-bg">修改路线</el-button> -->
                <el-button v-if="scope.row.status === 0" size="mini" type="danger" @click="deleteClick(scope.row.id)">删除 </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog v-dialog-drag="{ width: '80vw', marginTop: '5vh', isFullscreen: false }" title="详情" :visible.sync="detailDialogVisible" @close="dialogCloseDetail" width="800px" center>
      <div class="detail">
        <div v-loading="detailLoading">
          <div class="baseInfo">
            <div class="baseInfoTitle">
              <div class="line" />
              <span>基础信息</span>
            </div>
            <div class="baseInfoContent">
              <div class="baseInfoContentItem">
                <span class="span1">供应商名称：</span>
                <span>{{ detailData.supplierName }}</span>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">船舶名称：</span>
                  <span>{{ detailData.shipName }}</span>
                </div>
                <div>
                  <span class="span1">航次编号：</span>
                  <span>{{ detailData.voyageNumber }}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">船长姓名：</span>
                  <span>{{ detailData.captainName }}</span>
                </div>
                <div>
                  <span class="span1">船长电话：</span>
                  <span>{{ detailData.captainTel }}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">预装车数量：</span>
                  <span>{{ convert0(1, 1, detailData.loadingNum) }}</span>
                </div>
                <div>
                  <span class="span1">已装车数量：</span>
                  <span>{{ convert0(1, 1, detailData.leftoverNum) }}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <span class="span1">实际装车数量：</span>
                <template v-if="!!(carOperationRecord && carOperationRecord.totalNumber && carOperationRecord.totalNumber.length)">
                  <span v-for="(item, index) in carOperationRecord.totalNumber" :key="index">
                    {{ `${item.name}：${item.count};` }}
                  </span>
                </template>
                <span v-else>无</span>
              </div>
              <div class="baseInfoContentItem specialItem">
                <span class="span1">实际卸车数量：</span>
                <template v-if="!!(carOperationRecord && carOperationRecord.outNumber && carOperationRecord.outNumber.length)">
                  <span v-for="(item, index) in carOperationRecord.outNumber" :key="index">
                    {{ `${item.name}：${item.count};` }}
                  </span>
                </template>
                <span v-else>无</span>
              </div>
              <div class="baseInfoContentItem specialItem">
                <span class="span1">实际未卸车数量：</span>
                <template v-if="!!(carOperationRecord && carOperationRecord.inNumber && carOperationRecord.inNumber.length)">
                  <span v-for="(item, index) in carOperationRecord.inNumber" :key="index">
                    {{ `${item.name}：${item.count};` }}
                  </span>
                </template>
                <span v-else>无</span>
              </div>
              <!-- <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">船次：</span>
                  <span>{{detailData.voyageNumber}}</span>
                </div>
                <div>
                  <span class="span1">任务编号：</span>
                  <span>{{detailData.taskNumber}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">供应商名称：</span>
                  <span>{{detailData.supplierName}}</span>
                </div>
                <div>
                  <span class="span1">船舶名称：</span>
                  <span>{{detailData.shipName}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">航次编号：</span>
                  <span>{{detailData.voyageNumber}}</span>
                </div>
                <div>
                  <span class="span1">装车数量：</span>
                  <span>{{detailData.loadingNum}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">船长姓名：</span>
                  <span>{{detailData.captainName}}</span>
                </div>
                <div>
                  <span class="span1">船长电话：</span>
                  <span>{{detailData.captainTel}}</span>
                </div>
              </div> -->
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>作业港口</span>
            </div>
            <div class="operationTable">
              <el-table :data="portData" border style="width: 100%">
                <el-table-column prop="taskType" label="任务类型" align="center">
                  <template slot-scope="scope">{{ taskType(scope.row.taskType) }}</template>
                </el-table-column>
                <el-table-column prop="operationType" label="作业类型" align="center">
                  <template slot-scope="scope">{{ operationType(scope.row.operationType) }} </template>
                </el-table-column>
                <el-table-column prop="portName" label="作业港口" align="center" />
                <el-table-column prop="arrivalDate" label="进港时间" min-width="130" align="center" />
                <el-table-column prop="taskDate" label="装车时间" min-width="130" align="center" />
                <el-table-column label="预装车数量" align="center">
                  <template slot-scope="scope">
                    {{ operationType(scope.row.operationType) === '卸车' ? '0' : scope.row.loadingNum }}
                  </template>
                </el-table-column>
                <el-table-column label="实际装车数量" align="center">
                  <template slot-scope="scope">
                    {{ operationType(scope.row.operationType) === '卸车' ? '0' : scope.row.leftoverNum }}
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="portDetailed" label="港口详细地址" align="center"/>
                <el-table-column prop="portCoordinate" label="装车港口坐标" align="center"/> -->
                <el-table-column label="状态" align="center">
                  <div slot-scope="scope">{{ portStatus(scope.row.status) }}</div>
                </el-table-column>
                <el-table-column prop="xzjl" label="汇总" min-width="150" show-overflow-tooltip align="center" />
              </el-table>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>委托车信息</span>
            </div>
            <div class="operationTable">
              <div class="nav">
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">批次号：</p>
                  <el-input v-model="carList.batchNumber" size="mini" style="width: 135px" placeholder="输入批次号" />
                </div>
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">运单号：</p>
                  <el-input v-model="carList.waybillNo" size="mini" style="width: 135px" placeholder="输入运单号" />
                </div>
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">车架号：</p>
                  <el-input
                    v-model="carList.frameNumber"
                    size="mini"
                    style="width: 135px"
                    placeholder="输入车架号"
                    @paste.native.capture.prevent="
                      value => {
                        return searchCopyFormat(value, 'frameNumber');
                      }
                    " />
                </div>
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">品牌：</p>
                  <el-input v-model="carList.brand" size="mini" style="width: 135px" placeholder="输入品牌" />
                </div>
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">所在船舱：</p>
                  <el-input v-model="carList.shipCabinName" size="mini" style="width: 135px" placeholder="输入船舱" />
                </div>
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">起始港：</p>
                  <el-input v-model="carList.startPortName" size="mini" style="width: 135px" placeholder="输入起始港" />
                </div>
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">交车港：</p>
                  <el-input v-model="carList.deliveryPortName" size="mini" style="width: 135px" placeholder="输入交车港" />
                </div>
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">是否质损：</p>
                  <el-select v-model="carList.isMassLoss" style="width: 135px" size="mini" filterable clearable placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.lable" :value="item.value"></el-option>
                  </el-select>
                </div>
                <div class="navContainer" style="width: 160px">
                  <p style="font-size: 8px">状态：</p>
                  <el-select v-model="carList.state" style="width: 125px" size="mini" filterable clearable placeholder="请选择">
                    <el-option v-for="item in optionsState" :key="item.value" :label="item.lable" :value="item.value"></el-option>
                  </el-select>
                </div>
                <div class="navBtn">
                  <el-button size="small" class="searchBtn" @click="carpageList">查询</el-button>
                  <el-button size="small" class="resetBtn" @click="resetCar">重置</el-button>
                  <el-button size="small" type="primary" @click="exportClick">导出</el-button>
                  <el-button size="small" type="primary" @click="onClickEditSupplier" class="yellow-bg">修改供应商</el-button>
                </div>
              </div>
              <el-table ref="tableSupplierRef" :data="shipData" @selection-change="handleSelectionChangeSupplier" border style="width: 100%" max-height="200">
                <el-table-column type="selection" width="60" align="center" :reserve-selection="true" />
                <el-table-column prop="supplierName" label="实际供应商" min-width="150" align="center" />
                <el-table-column prop="batchNumber" label="批次号" min-width="100" align="center" />
                <el-table-column prop="waybillNo" label="运单编号" min-width="130" align="center" />
                <el-table-column prop="frameNumber" label="车架号" min-width="150" align="center" />
                <el-table-column prop="brand" label="品牌" align="center" />
                <el-table-column prop="model" label="型号" min-width="100" show-overflow-tooltip align="center" />
                <el-table-column prop="weight" label="重量" align="center" />
                <el-table-column prop="shipCabinName" label="所在船舱" align="center" />
                <el-table-column prop="startPortName" label="起始港名" align="center" />
                <el-table-column prop="arrivePort" label="目的港口" align="center" />
                <el-table-column prop="deliveryPortName" label="交车港名" align="center" />
                <el-table-column prop="loadingDate" label="装车时间" align="center" show-overflow-tooltip>
                  <div slot-scope="scope">
                    {{ getTime(scope.row.loadingDate, scope.row.state) }}
                  </div>
                </el-table-column>
                <el-table-column prop="deliveryDate" label="交车时间" align="center" show-overflow-tooltip>
                  <div slot-scope="scope">
                    {{ getTime(scope.row.deliveryDate, scope.row.state) }}
                  </div>
                </el-table-column>
                <el-table-column prop="taskType1" label="装车类型" align="center">
                  <div slot-scope="scope">{{ getTaskType1(scope.row.taskType1) }}</div>
                </el-table-column>
                <el-table-column prop="taskType2" label="卸车类型" align="center">
                  <div slot-scope="scope">{{ getTaskType2(scope.row.taskType2) }}</div>
                </el-table-column>
                <el-table-column prop="isMassLoss" label="是否质损" align="center">
                  <div slot-scope="scope">{{ scope.row.isMassLoss == 1 ? '是' : '否' }}</div>
                </el-table-column>
                <el-table-column label="状态" align="center">
                  <div slot-scope="scope">{{ getState(scope.row.state) }}</div>
                </el-table-column>
              </el-table>
              <div class="paginationContainer" style="margin: 10px 0 0 0">
                <span>共{{ detail.total }}条</span>
                <el-pagination background small :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="detail.total" :current-page.sync="detail.page" @size-change="detailSizeChange" @current-change="detailChange" @prev-click="detailChange" @next-click="detailChange" />
              </div>
            </div>
          </div>
          <div class="operation">
            <div class="baseInfoTitle">
              <div class="line" />
              <span>操作记录</span>
            </div>
            <div class="operationTable">
              <el-table :data="operationData" border style="width: 100%">
                <el-table-column label="操作时间" align="center" width="160px" prop="createTime"> </el-table-column>
                <el-table-column prop="operateType" label="操作类型" align="center" />
                <el-table-column prop="operationName" label="操作人" align="center" />
                <el-table-column prop="remark" label="备注" align="center" />
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" center @close="dialogClose" :close-on-click-modal="false" top="10vh">
      <div class="company">
        <el-form :model="teamData" label-width="140px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" prop="basic">
            <el-form-item label="选择船舶：" prop="ship" style="margin-top: 15px">
              <el-select v-model="teamData.ship" filterable size="mini" placeholder="请选择船舶" @change="shipChange" value-key="id" :disabled="dialogTitle == '修改船舶调配'">
                <el-option v-for="item in shipOption" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <div class="showDetails" style="width: 80%; margin: 0px auto 10px" v-if="teamData.ship && dialogTitle != '修改船舶调配'">
              <el-row>
                <el-col :span="12" style="position: relative">
                  <el-form-item label="载重吨 :" label-width="80px">
                    {{ shipDetails.loadTon ? shipDetails.loadTon : '-' }}
                  </el-form-item>
                </el-col>
                <el-col :span="12" style="position: relative">
                  <el-form-item label="剩余载重吨 :" label-width="92px">
                    {{ shipDetails.surplusLoadTon ? shipDetails.surplusLoadTon : '-' }}
                  </el-form-item>
                </el-col>
                <el-col :span="24" style="position: relative">
                  <el-form-item label="航次 :" label-width="80px">
                    {{ shipDetails.voyage ? shipDetails.voyage : '-' }}
                  </el-form-item>
                </el-col>
                <el-col :span="12" style="position: relative">
                  <el-form-item label="出港码头 :" label-width="80px">
                    {{ shipDetails.start ? shipDetails.start : '-' }}
                  </el-form-item>
                </el-col>
                <el-col :span="12" style="position: relative">
                  <el-form-item label="到达码头 :" label-width="92px">
                    {{ shipDetails.end ? shipDetails.end : '-' }}
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <!-- <el-form-item label="装车港口：" prop="start_port">
               <el-select v-model="teamData.start_port" size="mini"  placeholder="请选择装车港口" value-key="id" @change="portChange">
                 <el-option v-for="item in startOption" :key="item.id" :label="item.name" :value="item"/>
               </el-select>
             </el-form-item>
             <el-form-item label="装车数量：" prop="car1">
               <el-input
                 v-model="teamData.car1"
                 size="mini"
                 placeholder="请选择装车数量"
               />
             </el-form-item>
             <el-form-item label="装车时间：" prop="time" style="margin-bottom: 20px;">
               <el-date-picker
                 type="datetime"
                 v-model="teamData.time"
                 size="mini"
                 value-format="yyyy-MM-dd HH:mm:ss"
                 placeholder="请选择装车时间"/>
             </el-form-item>
           </div> -->
          </div-border>
          <div-border label="添加装船港口" prop="infor">
            <div class="productTable" style="margin: 20px 0">
              <div style="width: 100%" v-for="(item1, index) in teamData.shipment" :key="index">
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="装车港口：" :prop="`shipment[${index}].start_port`" :rules="rules.start_port">
                      <el-select v-model="item1.start_port" filterable :disabled="dialogTitle == '修改船舶调配' && item1.status != 0" style="width: 100%" size="mini" placeholder="请选择交车港口" value-key="id" @change="portChange($event, index)">
                        <el-option v-for="item in startOption" :key="item.id" :label="item.supplier_name" :value="item" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="预装车数量" :prop="`shipment[${index}].entruckNum`" :rules="rules.entruckNum">
                      <el-input :disabled="dialogTitle == '修改船舶调配' && item1.status != 0" v-model="item1.entruckNum" style="width: 100%" size="mini" placeholder="请输入预装车数量" />
                    </el-form-item>
                  </el-col>
                  <i class="el-icon-error" style="margin-left: 20px; font-size: 20px; cursor: pointer" v-show="teamData.shipment.length > 1" v-if="dialogTitle != '修改船舶调配'" @click="deletePort(index)"></i>
                  <i class="el-icon-error" style="margin-left: 20px; font-size: 20px; cursor: pointer" v-show="teamData.shipment.length > 1" v-if="dialogTitle == '修改船舶调配' && item1.status == 0" @click="deletePort(index)"></i>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="进港时间：" :prop="`shipment[${index}].arrivalTime`" :rules="rules.arrivalTime">
                      <el-date-picker type="datetime" style="width: 100%" v-model="item1.arrivalTime" size="mini" @change="timeChange($event, index, 'arrivalTime')" value-format="yyyy-MM-dd HH:mm:ss" :disabled="dialogTitle == '修改船舶调配' && item1.status != 0" placeholder="请选择进港时间" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="装车时间：" :prop="`shipment[${index}].entruckTime`" :rules="rules.entruckTime">
                      <el-date-picker type="datetime" v-model="item1.entruckTime" style="width: 100%" size="mini" @change="timeChange($event, index, 'entruckTime')" :disabled="dialogTitle == '修改船舶调配' && item1.status != 0" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择装车时间" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <el-col :span="10">
                    <el-form-item label="装车数量：" :prop="`shipment[${index}].entruckNumber`" :rules="rules.entruckNumber" class="Number">
                      <span>{{item1.entruckNumber}}</span>
                      <span style="color: #0000cc;cursor: pointer;margin-left: 20px" @click="addEntrustModify(index)">
                        修改
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="可调配数量：" class="Number">
                      <span style="display:inline-block;width:70px">{{item1.loadNum}}</span>
                    <el-button size="small" :loading="loading1" type="primary" @click="oneLoading(index)">一键装车</el-button>
                    </el-form-item>
                  </el-col>
                </el-row> -->
                <el-row>
                  <hr style="width: 100%" />
                </el-row>
              </div>
            </div>
            <div style="color: #0000cc; cursor: pointer; margin: -10px 0 10px 20px; width: fit-content" @click="addMaterial">添加</div>
          </div-border>
          <div class="btnContainer">
            <el-button class="searchBtn" :loading="loading" @click="saveClick" size="small">确定 </el-button>
            <el-button class="resetBtn" @click="dialogClose" size="small">取消</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="修改路线" :visible.sync="routerDialogVisible" width="650px" center :close-on-click-modal="false" top="10vh">
      <div class="router">
        <el-form :model="routerData" label-width="110px" :rules="rules1" ref="ruleForm1">
          <div class="transport">
            <!--            <el-form-item label="基础数据" prop="basic" class="transportTitle"/>-->
            <div-border label="基础信息">
              <div class="baseInfoContent">
                <div class="baseInfoContentItem">
                  <span style="color: #606266; font-weight: 700">任务编号：</span>
                  <span>{{ routerData.num }}</span>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span style="color: #606266; font-weight: 700">船舶名称：</span>
                    <span>{{ routerData.name }}</span>
                  </div>
                  <div>
                    <span style="color: #606266; font-weight: 700">航次：</span>
                    <span>{{ routerData.voyage }}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem" style="margin-bottom: 0">
                  <span style="color: #606266; font-weight: 700">起始港口：</span>
                  <span>{{ routerData.start }}</span>
                </div>
                <div class="addressItem">{{ routerData.startAddress }}</div>
                <div class="baseInfoContentItem" style="margin-bottom: 0">
                  <span style="color: #606266; font-weight: 700">到达港口：</span>
                  <span>{{ routerData.end }}</span>
                </div>
                <div class="addressItem">{{ routerData.endAddress }}</div>
                <div class="baseInfoContentItem">
                  <span style="color: #606266; font-weight: 700">装车时间：</span>
                  <span>{{ routerData.time }}</span>
                </div>
              </div>
            </div-border>
          </div>
          <div class="transport">
            <div-border label="修改交车地址">
              <el-form-item label="选择新港口：" prop="port2" style="margin-top: 15px">
                <el-select v-model="routerData.port" filterable size="mini" style="width: 100%" placeholder="请选择新港口" value-key="key">
                  <el-option v-for="item in portOption" :key="item.label" :label="item.label" :value="item" />
                </el-select>
                <span v-if="routerData.port2 !== ''" style="color: #999; font-size: 12px; position: absolute; bottom: -25px; left: 0">{{ routerData.port.address }}</span>
              </el-form-item>
              <el-form-item label="进港时间：" prop="time1">
                <el-date-picker v-model="routerData.time1" size="mini" type="datetime" placeholder="选择进港时间" />
              </el-form-item>
              <el-form-item label="出港时间：" prop="time2">
                <el-date-picker v-model="routerData.time2" size="mini" type="datetime" placeholder="选择进港时间" />
              </el-form-item>
              <el-form-item label="卸车时间：" prop="time3" style="margin-bottom: 20px">
                <el-date-picker v-model="routerData.time3" size="mini" type="datetime" placeholder="选择进港时间" />
              </el-form-item>
            </div-border>
          </div>
          <div class="transport">
            <div-border label="选择委托车">
              <el-table :data="routerData.table" border style="width: 100%; margin-top: 10px" @selection-change="handleSelectionChange2">
                <el-table-column type="selection" width="25" />
                <el-table-column prop="batch" label="批次号" align="center" />
                <el-table-column prop="chassis" label="车架号" align="center" />
                <el-table-column prop="brand" label="品牌" align="center" />
                <el-table-column prop="type" label="型号" align="center" />
                <el-table-column prop="config" label="配置" align="center" />
                <el-table-column prop="color" label="颜色" align="center" />
                <el-table-column prop="weight" label="重量" align="center" />
                <el-table-column prop="size" label="长x宽x高" align="center" />
                <el-table-column prop="remark" label="附件" align="center" />
                <el-table-column prop="state" label="状态" align="center" />
              </el-table>
            </div-border>
          </div>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" @click="routerBtnClick">确定</el-button>
            <el-button size="medium" class="resetBtn" @click="routerClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="选择委托车" :visible.sync="dialogEntrust" width="800px" center @close="dialogEntrustClose" :close-on-click-modal="false" top="10vh">
      <el-form :model="EntrustForm" label-width="60px" :inline="true" style="margin: 20px" class="entrust-form">
        <div>
          <el-form-item label="批次号">
            <el-input size="mini" v-model="EntrustForm.batchNumber" placeholder="请输入批次号"></el-input>
          </el-form-item>
          <el-form-item label="运单号">
            <el-input size="mini" v-model="EntrustForm.waybillNo" placeholder="请输入运单号"></el-input>
          </el-form-item>
          <el-form-item label="车架号">
            <el-input size="mini" v-model="EntrustForm.frameNumber" placeholder="请输入车架号"></el-input>
          </el-form-item>
          <el-form-item label="车型">
            <el-cascader
              v-model="EntrustForm.model"
              size="mini"
              filterable
              style="width: 100%"
              :options="modelOption"
              :props="{
                value: 'id',
                label: 'model',
                children: 'carModel',
                checkStrictly: true,
              }"
              placeholder="请选择车型" />
          </el-form-item>
          <el-form-item>
            <el-button size="mini" class="searchBtn" @click="EntrustSearchBtn">查询</el-button>
            <el-button size="mini" class="resetBtn" @click="EntrustResetBtn">重置</el-button>
          </el-form-item>
        </div>
        <div>
          <span style="color: red; float: right; padding: 0 5px 5px 0">剩余载重吨 : {{ allWeight ? allWeight : '-' }}</span>
          <el-table ref="entrustRef" :data="EntrustTable" v-loading="tableLoad" style="width: 100%" border :header-cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '35px' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }" tooltip-effect="dark" row-key="id" @select="EntrustSelectChange" @select-all="allEntrustSelectChange">
            <el-table-column type="selection" reserve-selection width="50" align="center"></el-table-column>
            <el-table-column label="批次号" prop="batchNumber" width="130" align="center" />
            <el-table-column label="运单号" prop="waybillNo" width="130" align="center" />
            <el-table-column label="车架号" prop="frameNumber" width="130" align="center" />
            <el-table-column label="品牌" prop="brandName" align="center" />
            <el-table-column label="型号" prop="modelName" width="150" align="center" />
            <el-table-column label="重量" prop="weight" width="60" align="center" />
            <el-table-column label="附件" prop="fileName" align="center" />
          </el-table>
          <div style="margin-top: 20px">
            <span style="vertical-align: sub">共{{ total }}条</span>
            <el-pagination background style="display: inline-block" :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" :current-page.sync="EntrustForm.page" @size-change="contractSizeChange1" @current-change="contractCurrentChange1" @prev-click="contractCurrentChange1" @next-click="contractCurrentChange1" />
          </div>
        </div>
        <div class="footer">
          <el-form-item>
            <el-button size="mini" class="searchBtn" @click="shipSure">确定</el-button>
            <el-button size="mini" class="resetBtn" @click="dialogEntrustClose">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- 添加港口 -->
    <el-dialog title="添加装船港口" :visible.sync="portVisible" width="700px" center @close="portClose" :close-on-click-modal="false" top="10vh">
      <div class="company">
        <el-form :model="addPortData" label-width="140px" :rules="portRules" ref="portForm">
          <div class="productTable" style="margin: 20px 0">
            <div style="width: 100%" v-for="(item, index) in addPortData.list" :key="index">
              <el-row>
                <el-col :span="11">
                  <el-form-item label="装车港口：" :prop="`list[${index}].loadPort`" :rules="portRules.loadPort">
                    <el-select v-model="item.loadPort" filterable style="width: 100%" size="mini" placeholder="请选择交车港口" value-key="id" @change="addPortChange($event, index)">
                      <el-option v-for="item in startOption" :key="item.id" :label="item.supplier_name" :value="item" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="预装车数量：" :prop="`list[${index}].entruckNum`" :rules="portRules.entruckNum">
                    <el-input v-model="item.entruckNum" style="width: 100%" size="mini" placeholder="请输入预装车数量" />
                  </el-form-item>
                </el-col>
                <i class="el-icon-error" style="margin-left: 20px; font-size: 20px; cursor: pointer" v-show="addPortData.list.length > 1" @click="delPortClick(index)"></i>
              </el-row>
              <el-row>
                <el-col :span="11">
                  <el-form-item label="进港时间：" :prop="`list[${index}].arrivalTime`" :rules="portRules.arrivalTime">
                    <el-date-picker type="datetime" style="width: 100%" v-model="item.arrivalTime" size="mini" @change="dateChange($event, index, 'arrivalTime')" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择进港时间" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="装车时间：" :prop="`list[${index}].entruckTime`" :rules="portRules.entruckTime">
                    <el-date-picker type="datetime" v-model="item.entruckTime" style="width: 100%" size="mini" @change="dateChange($event, index, 'entruckTime')" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择装车时间" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <hr style="width: 100%" />
              </el-row>
            </div>
          </div>
          <div style="color: #0000cc; cursor: pointer; margin: -10px 0 10px 20px; width: fit-content" @click="addPortClick">添加</div>
          <div class="btnContainer">
            <el-button class="searchBtn" :loading="loading" @click="portConfirm" size="small">确定 </el-button>
            <el-button class="resetBtn" @click="portClose" size="small">取消</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 修改供应商 -->
    <el-dialog title="修改供应商" :visible.sync="supplierVisible" @close="supplierClose" center width="500px">
      <div class="p30 pb0">
        <el-form :model="supplierData" label-width="100px" :rules="supplierRules" ref="supplierForm">
          <el-form-item label="供应商：" prop="port">
            <el-select v-model="supplierData.supplierId" class="w300" @change="handleChangeSupplierId" filterable clearable size="mini" value-key="id" placeholder="请选择供应商">
              <el-option v-for="item in nameOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="supplierCloseDialog">取 消</el-button>
        <el-button size="mini" :loading="supplierSureLoad" type="primary" @click="supplierFinish">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import { dockInfoDetailPageList, shipDeployPageList, oneLoading, shipDeploySelectShipAvailable, supplierPublicSelectPort, vehiclGetChildByPosition, shipDeployAdd, vehicleDetailPageList, shipDeployDelete, shipDeployFinish, shipDeployDetail, shipDeployUpdateDetail, shipDeployUpdate, loadPortAdd, updateSupplierByCarIdsShip } from '@/service/vehiclelog';
  import { highwayLineSelectWaterSupplier } from '@/service/financial';
  import { baseUrl } from '@/config/env';
  import { getSessionStore } from '@/config/mUtils';
  import { getCarSerieList } from '@/service/financial';
  import { formatDateTime, formatTime } from '@/config/mUtils';
  import addEntrust from '../waterway/compoent/addEntrust';

  export default {
    components: {
      divBorder,
      addEntrust,
    },
    data() {
      let validatePass2 = function (rule, value, callback) {
        if (Number(value) === 0) {
          callback(new Error('装车数量必须选择一条!'));
        }
        callback();
      };
      return {
        supplierRules: {},
        supplierSureLoad: false,
        nameOption: [],
        supplierData: {
          supplierId: '',
        },
        supplierVisible: false,
        selectedSupplier: [],
        options: [
          {
            value: '0',
            lable: '否',
          },
          {
            value: '1',
            lable: '是',
          },
        ],
        optionsState: [
          {
            value: '0',
            lable: '待装车',
          },
          {
            value: '1',
            lable: '已装船',
          },
          {
            value: '2',
            lable: '已交车',
          },
          {
            value: '-1',
            lable: '已取消',
          },
        ],
        carList: {
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          shipCabinName: '',
          startPortName: '',
          deliveryPortName: '',
          isMassLoss: '',
          state: '',
        },
        taskIpt: '',
        voyageIpt: '',
        shipIpt: '',
        // timeIpt:'',
        state: '',
        startTime: '',
        endTime: '',
        selectData: [],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        // 详情
        detailDialogVisible: false,
        detailData: {},
        carOperationRecord: {},
        detail: {
          page: 1,
          total: 0,
          size: 10,
        },
        operationData: [],
        shipData: [],

        // 新增/修改
        dialogTitle: '',
        dialogVisible: false,
        dialogEntrust: false,
        EntrustTableIndex: '',
        entrustId: '',
        checkTable: [], // 复选框选中数据
        routerDialogVisible: false,
        restaurants: [{ value: '船舶1' }, { value: '船舶2' }, { value: '船舶3' }, { value: '船舶4' }],
        portOption: [],
        routerData: {
          name: '',
          voyage: '',
          start: '',
          startAddress: '',
          end: '',
          endAddress: '',
          port: {
            value: '',
            key: '',
            address: '',
            label: '',
          },
        },
        rules1: {
          basic: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          router: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          port2: [
            {
              required: true,
              message: '请选择新港口',
              trigger: 'blur',
            },
          ],
          time1: [
            {
              required: true,
              message: '请选择进港时间',
              trigger: 'blur',
            },
          ],
          time2: [
            {
              required: true,
              message: '请选择出港时间',
              trigger: 'blur',
            },
          ],
          time3: [
            {
              required: true,
              message: '请选择卸车时间',
              trigger: 'blur',
            },
          ],
        },
        shipOption: [],
        startOption: [],
        stateOption: [
          {
            val: '',
            name: '全部',
          },
          {
            val: '0',
            name: '待执行',
          },
          {
            val: '1',
            name: '执行中',
          },
          {
            val: '2',
            name: '已完成',
          },
        ],
        loading: false,
        shipTable: [],
        portData: [],
        shipDetailData: [],
        teamData: {
          ship: '',
          time: '',
          shipData: {},
          shipment: [
            {
              start_port: '',
              arrivalTime: '',
              entruckTime: '',
              entruckNum: '',
              loadNum: '0',
              entruckNumber: '0',
              entrustId: [],
            },
          ],
        },
        shipDetails: [],
        positionId: [],
        rules: {
          ship: [
            {
              required: true,
              message: '请输入船舶名称',
              trigger: 'change',
            },
          ],
          start_port: [
            {
              required: true,
              message: '交车港口',
              trigger: 'change',
            },
          ],
          car1: [
            {
              required: true,
              message: '请输入交车港口',
              trigger: 'change',
            },
          ],
          basic: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          arrivalTime: [
            {
              required: true,
              message: '请选择进港时间',
              trigger: 'change',
            },
          ],
          entruckTime: [
            {
              required: true,
              message: '请选择装车时间',
              trigger: 'change',
            },
          ],
          entruckNum: {
            required: true,
            message: '请输入预装车数量',
            trigger: 'change',
          },
          entruckNumber: [
            {
              required: true,
              message: '请选择装车数量',
              trigger: 'change',
            },
            {
              validator: validatePass2,
              trigger: 'blur',
            },
          ],
          infor: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
        },
        // 选择委托车列表数据
        EntrustTable: [],
        staticWeight: 0, // 所有剩余载重
        allWeight: 0, // 剩余载重
        weights: [0], // 已使用载重吨
        EntrustForm: {
          batchNumber: '',
          frameNumber: '',
          waybillNo: '',
          model: '',
          page: 1,
          rows: 10,
        },
        modelOption: [], // 品牌/型号
        loading1: false, // 一键装车

        // 添加港口
        portVisible: false,
        addPortData: {
          list: [
            {
              loadPort: '',
              entruckNum: '',
              arrivalTime: '',
              entruckTime: '',
            },
          ],
        },
        portRules: {
          loadPort: {
            required: true,
            message: '请选择港口',
            trigger: 'change',
          },
          entruckNum: {
            required: true,
            message: '请输入预装车数量',
            trigger: 'change',
          },
          arrivalTime: {
            required: true,
            message: '请选择进港时间',
            trigger: 'change',
          },
          entruckTime: {
            required: true,
            message: '请选择装车时间',
            trigger: 'change',
          },
        },
        detailLoading: false,
      };
    },
    computed: {
      getShipState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待执行';
            case 1:
              return '执行中';
            case 2:
              return '已完成';
          }
        };
      },
      portStatus() {
        return function (state) {
          switch (state) {
            case 0:
              return '待执行';
            case 1:
              return '执行中';
            case 2:
              return '已完成';
          }
        };
      },
      taskType() {
        return function (state) {
          switch (state) {
            case 0:
              return '正常作业';
            case 1:
              return '过驳';
            case 2:
              return '转船';
          }
        };
      },
      operationType() {
        return function (state) {
          switch (state) {
            case 0:
              return '装车';
            case 1:
              return '卸车';
          }
        };
      },
      getTime() {
        return function (time, type) {
          if (type != 1 || (type == 1 && time != undefined)) {
            return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
          } else if (type == 1 && time == null) {
            return null;
          }
          // return formatDateTime(time,'yyyy-mm-dd hh:ii:ss')
        };
      },
    },
    provide() {
      return {
        CloseDialog: this.dialogEntrustClose,
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      // 预计到港时间开始-结束日期验证
      dateChange1(val) {
        if (this.endTime && this.startTime && this.endTime <= this.startTime) {
          if (val == this.endTime) this.endTime = '';
          if (val == this.startTime) this.startTime = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      async supplierFinish() {
        // console.log(this.selectedSupplier);
        this.supplierSureLoad = true;
        const ids = this.selectedSupplier.map(item => item.id).join(',');
        console.log(ids);
        console.log(this.supplierData.supplierId);
        const resi = await updateSupplierByCarIdsShip({
          ids: ids,
          supplierId: this.supplierData.supplierId,
        });
        console.log(resi);
        if (resi.status != 0) {
          this.$message.warning(resi.message);
        } else {
          this.$message.success(resi.message);
          this.supplierVisible = false;
          // console.log('<<<');
          // this.carpageList()
          this.loadingFunction();
          this.detailLoading = true;
          const res = await shipDeployDetail(this.detail.id);
          // console.log(res);

          if (res.status !== 0) return this.$message.error(res.message);
          this.detailData = res.data.detailData;
          this.carOperationRecord = res.data.carCount;
          this.operationData = res.data.detailData.operateRecordList;
          this.portData = res.data.detailData.portList;
          await this._carPageList();
          this.$refs.tableSupplierRef.clearSelection();
          this.detailLoading = false;
        }
        this.supplierSureLoad = false;
      },
      supplierCloseDialog() {
        this.supplierVisible = false;
      },
      handleChangeSupplierId() {},
      supplierClose() {
        this.supplierData.supplierId = '';
      },
      dialogCloseDetail() {
        this.selectedSupplier = [];
        this.$refs.tableSupplierRef.clearSelection();
      },
      async onClickEditSupplier() {
        console.log(this.selectedSupplier);
        const { status, message, data } = await highwayLineSelectWaterSupplier();
        if (status !== 0) return this.$message.warning(message);
        // this.thirdPartySupplierOptions = data;
        this.nameOption = data;
        this.supplierVisible = true;
      },
      handleSelectionChangeSupplier(val) {
        this.selectedSupplier = val;
      },
      async carpageList() {
        //委托车信息查询
        // debugger;
        let data = {
          basicId: this.detail.id,
          batchNumber: this.carList.batchNumber,
          waybillNo: this.carList.waybillNo,
          frameNumber: this.carList.frameNumber,
          brand: this.carList.brand,
          shipCabinName: this.carList.shipCabinName,
          startPortName: this.carList.startPortName,
          deliveryPortName: this.carList.deliveryPortName,
          isMassLoss: this.carList.isMassLoss,
          state: this.carList.state,
        };
        const res = await dockInfoDetailPageList(data);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detail.total = res.data.total;
        this.shipData = res.data.records;
      },
      exportClick() {
        //导出
        // var href = window.location.host;
        // if(href=='mslogistics.cn'){
        //     href ='https://'+href;
        // }else {
        //   href ='http://'+href.split(':')[0]+':9200';
        // }
        let token = getSessionStore('token');
        let url = baseUrl + '/platform/vehicleDeployCar/carExport';
        // url += '?supplierName='+this.teamIpt;
        url += '?basicId=' + this.detail.id + '&batchNumber=' + this.carList.batchNumber;
        url += '&waybillNo=' + this.carList.waybillNo + '&frameNumber=' + this.carList.frameNumber;
        url += '&brand=' + this.carList.brand + '&shipCabinName=' + this.carList.shipCabinName;
        url += '&startPortName=' + this.carList.startPortName + '&deliveryPortName=' + this.carList.deliveryPortName;
        url += '&isMassLoss=' + this.carList.isMassLoss + '&state=' + this.carList.state;
        url += '&access_token=' + token;
        window.location.href = url;
      },
      resetCar() {
        this.carList = {
          basicId: '',
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          shipCabinName: '',
          startPortName: '',
          deliveryPortName: '',
          isMassLoss: '',
          state: '',
        };
      },
      async init() {
        //await this._shipDeployPageList();
        // await this._getLoadingPort();
      },
      // 分页查询
      async _shipDeployPageList() {
        this.tableLoad = true;
        const res = await shipDeployPageList({
          shipName: this.shipIpt,
          voyageNumber: this.voyageIpt,
          // taskNumber:this.taskIpt,
          supplierName: this.taskIpt,
          status: this.state,
          startTime:this.startTime,
          endTime:this.endTime,
          // startTime:this.timeIpt[0]?this.timeIpt[0]:'',
          // endTime:this.timeIpt[1]?this.timeIpt[1]:'',
          rows: this.size,
          page: this.page,
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 结束时间
      // dateChange(val) {
      //   if (this.endTime && this.startTime && this.endTime <= this.startTime) {
      //     if (val == this.endTime) this.endTime = '';
      //     if (val == this.startTime) this.startTime = '';
      //     return this.$message.warning('结束日期必须大于开始日期！');
      //   }
      // },
      routerBtnClick() {
        this.$refs.ruleForm1.validate(valid => {
          if (valid) {
            this.routerDialogVisible = false;
          } else {
            return false;
          }
        });
      },
      routerClose() {
        this.routerDialogVisible = false;
        this.$refs.ruleForm1.resetFields();
      },
      removeClick(index) {
        this.shipTable.splice(index, 1);
      },
      // 新增/修改 —— 保存
      saveClick() {
        // if (this.shipTable.length===0) return this.$message.warning("必须至少有一个车辆信息！");
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            this.loading = true;
            let obj = {};
            if (this.dialogTitle === '添加船舶调配') {
              obj = {
                shipId: this.teamData.ship,
                portList: this.teamData.shipment.map(item => {
                  let { start_port, entruckNum, arrivalTime, entruckTime, entruckNumber, entrustId } = item;
                  return {
                    portId: start_port.id, // 港口id
                    portName: start_port.supplier_name, // 港口名称
                    portDetailed: start_port.address, // 港口详细地址
                    portCoordinate: start_port.coordinate || '', // 港口坐标
                    loadingNum: entruckNum, // 预计装车数量
                    arrivalDate: arrivalTime, // 进港时间
                    taskDate: entruckTime, // 装车时间

                    // loadingNum: entruckNumber,
                    portAreaId: item.portAreaId,
                    portAreaFullId: item.portAreaFullId,
                    portAreaName: item.portAreaName,
                    // portCoordinate: item.portCoordinate,
                    // portId: item.portId,
                    // portName: item.portName,
                    //装车数量
                    // carList:entrustId.map(item=>{
                    //   return{
                    //     carId:item.id,
                    //   }
                    // }),
                  };
                }),
              };
            } else {
              obj = {
                id: this.teamData.id,
                shipId: this.teamData.shipId,
                portList: this.teamData.shipment.map(item => {
                  let { start_port, entruckNum, arrivalTime, entruckTime, entruckNumber, entrustId } = item;
                  return {
                    portId: start_port.id, // 港口id
                    portName: start_port.supplier_name, // 港口名称
                    portCoordinate: start_port.coordinate || '', // 港口坐标
                    loadingNum: entruckNum, // 预计装车数量
                    arrivalDate: arrivalTime, // 进港时间
                    taskDate: entruckTime, // 装车时间

                    portAreaId: item.portAreaId,
                    portAreaFullId: item.portAreaFullId,
                    portAreaName: item.portAreaName,
                  };
                }),
              };
            }
            console.log(obj);
            // return false
            const res = this.dialogTitle === '添加船舶调配' ? await shipDeployAdd(obj) : await shipDeployUpdate(obj);
            this.loading = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.dialogVisible = false;
            await this._shipDeployPageList();
          } else {
            return false;
          }
        });
      },
      // 数组求和
      sum(arr) {
        let s = 0;
        for (var i = arr.length - 1; i >= 0; i--) {
          s += arr[i];
        }
        return s;
      },
      // 一键装车
      async oneLoading(index) {
        this.shipDetails.surplusLoadTon = this.staticWeight - this.sum(this.weights);
        //检测是否选择港口
        if (this.teamData.ship === '') return this.$message.warning('请选择船舶');
        //检测是否选择港口
        if (this.teamData.shipment[index].start_port === '') return this.$message.warning('请选择装车港口');
        this.loading1 = true;
        let obj = {
          portId: this.teamData.shipment[index].start_port.id,
          load: this.allWeight,
        };
        let res = await oneLoading(obj);
        this.loading1 = false;
        if (res.status !== 0) return this.$message.error(res.message);
        let weight = 0;
        if (res.data.length > 0) {
          res.data.forEach(item => {
            weight += item.weight;
          });
          if (weight > this.shipDetails.surplusLoadTon) return this.$message.error('总重量必须小于剩余载重吨');
          this.weights[index] = weight;
          this.shipDetails.surplusLoadTon = this.staticWeight - this.sum(this.weights);
          this.allWeight = this.staticWeight - this.sum(this.weights);
          this.teamData.shipment[index].entruckNumber = res.data.length;
          this.teamData.shipment[index].entrustId = res.data;
          this.checkTable = res.data;
          this.entrustId = res.data;
        }
      },
      batchChange() {
        this.shipTable.forEach(item => {
          if (this.selectData.indexOf(item) !== -1) {
            item.port = this.teamData.carPort;
          }
        });
      },
      handleSelectionChange(val) {
        this.selectData = val;
      },
      handleSelectionChange2(val) {},
      contractSizeChange(sizes) {
        this.size = sizes;
        this._shipDeployPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._shipDeployPageList();
      },
      // 详情
      async detailClick(row) {
        this.resetCar();
        this.detail.page = 1;
        this.detail.id = row.id;
        this.detailDialogVisible = true;
        this.loadingFunction();
        this.detailLoading = true;
        const res = await shipDeployDetail(row.id);
        this.detailLoading = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data.detailData;
        this.carOperationRecord = res.data.carCount;
        this.operationData = res.data.detailData.operateRecordList;
        this.portData = res.data.detailData.portList;
        await this._carPageList();
      },
      // 详情 —— 分页查询
      async _carPageList() {
        let data = {
          basicId: this.detail.id,
          batchNumber: this.carList.batchNumber,
          waybillNo: this.carList.waybillNo,
          frameNumber: this.carList.frameNumber,
          brand: this.carList.brand,
          shipCabinName: this.carList.shipCabinName,
          startPortName: this.carList.startPortName,
          deliveryPortName: this.carList.deliveryPortName,
          isMassLoss: this.carList.isMassLoss,
          state: this.carList.state,
          rows: this.detail.size,
          page: this.detail.page,
        };
        // let obj = {
        //   basicId: this.detail.id,
        //   rows: this.detail.size,
        //   page: this.detail.page,
        // }
        const res = await vehicleDetailPageList(data);
        if (res.status !== 0) return this.$message.error(res.message);
        this.shipData = res.data.records;
        this.detail.total = res.data.total;
      },
      // 详情 —— 分页大小改变
      detailSizeChange(size) {
        // 每页条数
        this.detail.size = size;
        this._carPageList();
      },
      // 详情 —— 当前页改变
      detailChange(page) {
        // 翻页
        this.detail.page = page;
        this._carPageList();
      },

      loadingFunction() {
        this.$nextTick(() => {
          const loading = this.$loading({
            lock: true, //同v-loading的修饰符
            text: 'Loading', //加载文案
            backgroundColor: 'rgba(55,55,55,0.4)', //背景色
            spinner: 'el-icon-loading', //加载图标
            target: document.querySelector('.detail'), //loading需要覆盖的DOM节点，默认为body
          });
          clearTimeout();
          // setTimeout(()=>{
          loading.close();
          // },1000)
        });
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确定要删除当前船舶吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await shipDeployDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._shipDeployPageList();
          })
          .catch(() => {});
      },
      // 装车港口改变
      async portChange(value, index) {
        let flg = false;
        if (this.teamData.shipment.length > 0) {
          this.teamData.shipment.forEach(item => {
            if (item.portId == value.id) flg = true;
          });
        }
        if (flg) {
          this.teamData.shipment[index].start_port = '';
          return this.$message.warning('请选择不同的装车港口');
        }
        // this.positionId =value.area_id;
        this.positionId[index] = value.area_id;

        this.teamData.shipment[index].portAreaId = value.area_id;
        this.teamData.shipment[index].portAreaFullId = value.area_full_id;
        this.teamData.shipment[index].portAreaName = value.area;
        this.teamData.shipment[index].portCoordinate = value.coordinate;
        this.teamData.shipment[index].portId = value.id;
        this.teamData.shipment[index].portName = value.supplier_name;

        this.teamData.shipment[index].arrivalTime = '';
        this.teamData.shipment[index].entruckTime = '';
        this.teamData.shipment[index].entruckNumber = 0;
        this.teamData.shipment[index].loadNum = value.loadNum;
        this.$forceUpdate();
      },
      changeRouteClick() {
        this.routerData = {
          port2: '港口1',
          name: '船舶1',
          voyage: '20211012E',
          start: '港口1',
          startAddress: '重庆市渝中区xxxxxx',
          end: '港口2',
          endAddress: '重庆市渝中区xxxxxx',
          time: '2021-9-26 16:10',
          num: 'HB2021021021',
          time1: '',
          time2: '',
          time3: '',
          port: {
            value: '港口1',
            key: '01',
            address: '重庆市渝中区两路口1111111',
            label: '港口1',
          },
          table: [
            {
              batch: 'PC121541',
              chassis: 'DP121541',
              brand: '品牌1',
              type: '车型1',
              config: '配置1',
              color: '红色',
              weight: '20',
              size: '10x20x20',
              remark: '无',
              state: '托运中',
            },
            {
              batch: 'PC121541',
              chassis: 'DP121541',
              brand: '品牌1',
              type: '车型1',
              config: '配置1',
              color: '红色',
              weight: '20',
              size: '10x20x20',
              remark: '钥匙两把',
              state: '已到达',
            },
            {
              batch: 'PC121541',
              chassis: 'DP121541',
              brand: '品牌1',
              type: '车型1',
              config: '配置1',
              color: '红色',
              weight: '20',
              size: '10x20x20',
              remark: '无',
              state: '未开始',
            },
          ],
        };
        this.routerDialogVisible = true;
      },
      // 修改
      async changeClick(item) {
        this.dialogTitle = '修改船舶调配';
        this._getLoadingPort();
        const res = await shipDeployUpdateDetail(item.id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.dialogVisible = true;
        this.teamData = {
          ...res.data,
          // ship:{name:res.data.shipName,id:res.data.shipId},
          ship: res.data.shipName,
          shipment: [],
        };
        if (res.data.portList.length > 0) {
          res.data.portList.forEach((item, index) => {
            this.teamData.shipment.push({
              start_port: {
                id: item.portId,
                supplier_name: item.portName,
              },
              entruckNum: item.loadingNum,
              arrivalTime: item.arrivalDate,
              entruckTime: item.taskDate,
            });
            let temp = this.startOption.filter(item1 => {
              return item1.id == item.portId;
            })[0];
            this.portChange(temp, index);
            this.teamData.shipment[index].start_port = temp;
            this.teamData.shipment[index].entruckNum = item.loadingNum;
            this.teamData.shipment[index].arrivalTime = item.arrivalDate;
            this.teamData.shipment[index].entruckTime = item.taskDate;
            this.teamData.shipment[index].status = item.status;
          });
        }
      },
      searchBtn() {
        this.page = 1;
        this._shipDeployPageList();
      },
      resetBtn() {
        this.taskIpt = '';
        this.voyageIpt = '';
        this.shipIpt = '';
        this.state = '';
        // this.timeIpt='';
        this.startTime = '';
        this.endTime = '';
      },
      async _shipDeploySelectShipAvailable() {
        let res = await shipDeploySelectShipAvailable();
        if (res.status !== 0) return this.$message.error(res.message);
        this.shipDetailData = res.data;
        this.shipOption = res.data.map(item => {
          return {
            id: item.id,
            name: item.name,
          };
        });
      },
      // 获取装车港口
      async _getLoadingPort() {
        let res2 = await supplierPublicSelectPort();
        if (res2.status !== 0) return this.$message.error(res2.message);
        this.startOption = res2.data;
      },
      // 新增
      addBtn() {
        this._getLoadingPort();
        this.shipTable = [];
        this.teamData = {
          ship: '',
          time: '',
          shipData: [],
          shipment: [
            {
              start_port: '',
              arrivalTime: '',
              entruckTime: '',
              entruckNumber: '0',
              loadNum: '0',
              entrustId: [],
            },
          ],
        };
        this.dialogTitle = '添加船舶调配';
        this._getCarSerieList();
        this.dialogVisible = true;
        this._shipDeploySelectShipAvailable();
      },
      deletePort(index) {
        this.teamData.shipment.splice(index, 1);
      },
      // 装车时间/进港时间 验证
      timeChange(val, index, key) {
        if (this.teamData.shipment[index].arrivalTime && this.teamData.shipment[index].entruckTime) {
          if (this.teamData.shipment[index].arrivalTime >= this.teamData.shipment[index].entruckTime) {
            if (key == 'arrivalTime') {
              this.teamData.shipment[index].arrivalTime = '';
            }
            if (key == 'entruckTime') {
              this.teamData.shipment[index].entruckTime = '';
            }
            return this.$message.warning('装车时间必须大于进港时间！');
          }
        }
      },
      // 新增/修改 -- 添加装船港口
      addMaterial() {
        // console.log(this.teamData);
        this.teamData.shipment.push({
          start_port: '',
          status: 0,
          arrivalTime: '',
          entruckNum: '',
          entruckTime: '',
          loadNum: '0',
          entruckNumber: '0',
          entrustId: [],
        });
        this.weights.push(0);
      },
      // 装车港口 修改
      addEntrustModify(index) {
        //检测是否选择港口
        if (this.teamData.ship === '') return this.$message.warning('请选择船舶');
        //检测是否选择港口
        if (this.teamData.shipment[index].start_port === '') return this.$message.warning('请选择装车港口');
        //保存索引
        this.EntrustResetBtn();
        this.EntrustTableIndex = index;
        this.EntrustForm.page = 1;
        this.dialogEntrust = true;
        //如果 是添加，添加委托车后，再次点击，传入id用以回显
        this.$nextTick(() => {
          clearTimeout(this.timer);
          if (this.dialogTitle == '添加船舶调配') {
            this.entrustId = this.teamData.shipment[index].entrustId;
            if (this.entrustId.length > 0) {
              this.entrustId.forEach(item => {
                this.$refs.entrustRef.toggleRowSelection(item, true);
              });
            }
          }
          this._vehiclGetChildByPosition(index);
        });
      },
      // 航次完成
      deployClick(row) {
        this.$confirm('确认完成当前调配任务吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await shipDeployFinish(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._shipDeployPageList();
          })
          .catch(() => {});
      },
      // 弹窗关闭  调用子组件 清除勾选框
      dialogEntrustClose() {
        this.dialogEntrust = false;
      },

      // 添加港口 -- 打开弹窗
      openPort(row) {
        this._getLoadingPort();
        this.portVisible = true;
        this.addPortData = {
          id: row.id,
          list: [
            {
              loadPort: '',
              entruckNum: '',
              arrivalTime: '',
              entruckTime: '',
            },
          ],
        };
      },
      // 添加港口 -- 港口验证
      addPortChange(value, index) {
        let flg = false;
        if (this.addPortData.list.length > 0) {
          this.addPortData.list.forEach((item, ind) => {
            if (index != ind && item.loadPort.id == value.id) flg = true;
          });
        }
        if (flg) {
          this.addPortData.list[index].loadPort = '';
          return this.$message.warning('请选择不同的装车港口');
        }
      },
      // 添加港口 -- 时间验证
      dateChange(val, index, key) {
        if (this.addPortData.list[index].arrivalTime && this.addPortData.list[index].entruckTime) {
          if (this.addPortData.list[index].arrivalTime >= this.addPortData.list[index].entruckTime) {
            if (key == 'arrivalTime') {
              this.addPortData.list[index].arrivalTime = '';
            }
            if (key == 'entruckTime') {
              this.addPortData.list[index].entruckTime = '';
            }
            return this.$message.warning('装车时间必须大于进港时间！');
          }
        }
      },
      // 添加港口 -- 添加
      addPortClick() {
        this.addPortData.list.push({
          loadPort: '',
          entruckNum: '',
          arrivalTime: '',
          entruckTime: '',
        });
      },
      // 添加港口 -- 删除
      delPortClick(index) {
        this.addPortData.list.splice(index, 1);
      },
      // 添加港口 -- 确认
      portConfirm() {
        this.$refs.portForm.validate(async valid => {
          if (valid) {
            let obj = {
              id: this.addPortData.id,
              portList: this.addPortData.list.map(item => {
                return {
                  portId: item.loadPort.id,
                  arrivalDate: item.arrivalTime,
                  taskDate: item.entruckTime,
                  loadingNum: item.entruckNum,
                };
              }),
            };
            this.loading = true;
            const res = await loadPortAdd(obj);
            this.loading = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.portVisible = false;
            await this._shipDeployPageList();
          } else {
            return false;
          }
        });
      },
      // 添加港口 -- 取消
      portClose() {
        this.$refs.portForm.resetFields();
        this.addPortData = {};
        this.portVisible = false;
      },

      // 船舶调配 —— 品牌/型号
      async _getCarSerieList() {
        let res = await getCarSerieList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.modelOption = res.data.filter(item => {
          return item;
        });
        this.modelOption = this.modelOption.map(item => {
          return {
            ...item,
            model: item.brand,
          };
        });
      },
      // 船舶调配 —— 分页查询
      async _vehiclGetChildByPosition(index) {
        debugger;
        if (this.EntrustForm.model.length && this.EntrustForm.model.length > 0) {
          this.EntrustForm.model = this.EntrustForm.model[this.EntrustForm.model.length - 1];
        }
        // console.log(this.EntrustForm);
        // return false
        this.tableLoad = true;
        let res = await vehiclGetChildByPosition({
          positionType: 2,
          positionId: index ? this.positionId[index] : this.positionId[this.EntrustTableIndex],
          portId: index ? this.teamData.shipment[index].start_port.id : this.teamData.shipment[this.EntrustTableIndex].start_port.id,
          ...this.EntrustForm,
        });
        if (res.status !== 0) {
          this.tableLoad = false;
          return this.$message.error(res.message);
        }
        this.EntrustTable = res.data.records;
        this.total = res.data.total;
        this.tableLoad = false;
      },
      // 船舶调配 —— 复选框选中
      EntrustSelectChange(value, row) {
        let weight = 0;
        if (value && value.length > 0) {
          value.forEach(item => {
            weight += item.weight;
          });
        }
        if (weight > this.staticWeight) {
          this.$refs.entrustRef.toggleRowSelection(row, false);
          return this.$message.warning('总重量必须小于剩余载重吨');
        } else {
          let temp = this.weights;
          temp[this.EntrustTableIndex] = weight;
          console.log(this.staticWeight, temp, this.sum(this.weights));
          this.allWeight = this.staticWeight - this.sum(temp);
          if (value.length && value.length > 0) {
            this.checkTable = value;
          }
        }
      },
      // 船舶调配 —— 全选
      allEntrustSelectChange(value) {
        let weight = 0;
        if (value && value.length > 0) {
          value.forEach(item => {
            weight += item.weight;
          });
        }
        if (weight > this.staticWeight) {
          if (value.length > 0) {
            this.$refs.entrustRef.clearSelection();
          }
          return this.$message.warning('总重量必须小于剩余载重吨');
        } else {
          let temp = this.weights;
          temp[this.EntrustTableIndex] = weight;
          this.allWeight = this.staticWeight - this.sum(temp);
          if (value.length && value.length > 0) {
            this.checkTable = value;
          }
        }
      },
      // 船舶调配 —— 分页
      contractSizeChange1(size) {
        debugger;
        this.EntrustForm.rows = size;
        this._vehiclGetChildByPosition();
      },
      contractCurrentChange1(page) {
        debugger;
        this.EntrustForm.page = page;
        this._vehiclGetChildByPosition();
      },
      // 船舶调配 —— 查询
      EntrustSearchBtn() {
        debugger;
        this.EntrustForm.page = 1;
        this._vehiclGetChildByPosition();
      },
      // 船舶调配 —— 重置
      EntrustResetBtn() {
        for (let argumentsKey in this.EntrustForm) {
          this.EntrustForm[argumentsKey] = '';
        }
        this.EntrustForm.page = 1;
        this.EntrustForm.rows = 10;
      },
      // 船舶调配 —— 确定
      shipSure() {
        this.entrustId = this.checkTable;
        this.teamData.shipment[this.EntrustTableIndex].entrustId = this.checkTable;
        if (this.teamData.shipment.length > 0) {
          this.teamData.shipment.forEach(item => {
            item.entruckNumber = item.entrustId.length;
          });
        }
        this.weights[this.EntrustTableIndex] = this.shipDetails.surplusLoadTon - this.allWeight;
        this.shipDetails.surplusLoadTon = this.allWeight;
        this.dialogEntrust = false;
        console.log(this.weights);
        this.$forceUpdate();
      },

      // 状态
      getState(state) {
        switch (state) {
          case 0:
            return '待装车';
          case 1:
            return '已装船 ';
          case 2:
            return '已交车';
          case -1:
            return '已取消';
        }
      },
      // 装车类型
      getTaskType1(val) {
        switch (val) {
          case 0:
            return '正常装车';
          case 1:
            return '过驳 ';
          case 2:
            return '转船';
        }
      },
      // 卸车类型
      getTaskType2(val) {
        switch (val) {
          case 0:
            return '正常卸车';
          case 1:
            return '过驳 ';
          case 2:
            return '转船';
        }
      },

      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      // 新增/修改弹窗 —— 选择船舶改变
      async shipChange(value) {
        this.shipDetailData.forEach((item, index) => {
          if (item.id === value) {
            if (item.voyageList[0]) {
              let { status, leave_port_addr, voyage_number, start_port_name, delivery_port_name } = item.voyageList[0];
              this.shipDetails = {
                state: this.getShipState(status),
                location: leave_port_addr,
                voyage: voyage_number,
                start: start_port_name,
                // startAddress:leave_port_addr,
                end: delivery_port_name,
                // endAddress:arrival_port_addr,
              };
            } else {
              this.shipDetails = {
                state: '',
                location: '',
                voyage: '',
                start: '',
                end: '',
                loadTon: '',
                surplusLoadTon: '',
              };
            }
            this.shipDetails.loadTon = item.loadTon;
            this.shipDetails.surplusLoadTon = item.surplusLoadTon;
            this.staticWeight = item.surplusLoadTon;
          }
        });
        // console.log(this.shipDetails);
        this.allWeight = this.shipDetails.surplusLoadTon;
      },
      // 将null转换为0
      convert0(row, column, cellValue) {
        if (cellValue) {
          return cellValue;
        } else {
          return '0';
        }
      },
      // 将null转换为0
      convert1(row, column, cellValue) {
        if (row.leftoverNum) {
          return row.leftoverNum - row.unloadedNumber;
        } else {
          return '0';
        }
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.carList.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 5px 0;

      button {
        margin: 0 15px;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .navContainer p {
        display: inline-block;
        width: 90px;
        text-align: right;
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        margin-left: 10px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .router {
      width: 100%;
      padding: 20px 20px 20px 10px;
      height: 80vh;
      overflow: auto;

      .transport {
        width: 100%;
        //border: 1px solid #C3C3C3;
        position: relative;
        padding: 0 10px;
        margin-bottom: 20px;

        .baseInfoContent {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          .addressItem {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }

          &Item {
            margin-bottom: 15px;

            span {
              color: #606266;
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }

        &Title {
          margin-bottom: 0;
          position: absolute;
          top: -21px;
          z-index: 999;
          background-color: #fff;
          left: 20px;
          padding-right: 10px;
          color: rgb(51, 84, 131);
          font-size: 15px;
          font-weight: 700;

          ::v-deep {
            .el-form-item__label {
              color: rgb(51, 84, 131);
              font-size: 15px;
            }
          }
        }
      }

      ::v-deep {
        .el-form-item {
          margin-bottom: 15px;
        }

        .el-table td,
        .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-checkbox__input {
          margin-left: 5px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            .addressItem {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
              margin-bottom: 10px;
              margin-left: 70px;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    ::v-deep.company {
      width: 100%;
      padding: 20px 10px 10px 10px;
      max-height: 80vh;
      // overflow:auto;
      .port-enter,
      .port-leave-to {
        opacity: 0;
        transform: translateY(150px);
      }

      .port-enter-active,
      .port-leave-active {
        transition: all 0.1s ease;
      }

      .el-select {
        width: 75%;
      }

      .showDetails {
        .el-form-item__content {
          margin-top: 9px;
          line-height: 20px;
        }

        .el-form-item {
          margin-bottom: 0;
        }

        .protAdderss {
          /*position: absolute;;*/
          /*!*margin-left: 69px;*!*/
          /*top: 36px;*/
          /*left: 51px;*/
          margin-left: 46px;
          color: #999999;
        }
      }

      .productTable {
        margin-top: 15px;

        .el-date-editor {
          width: 150px;
        }

        .el-form-item {
          margin-bottom: 10px;
        }

        .el-form-item__error {
          top: 90%;
        }

        .Number {
          .el-form-item__error {
            top: 66%;
          }
        }

        .tableAddBtnContainer {
          border: 1px solid #ebeef5;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #f59a23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }
      }

      .update {
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 15px;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__body i.el-icon-error {
      position: relative;
      top: 10px;
    }

    .el-form-item__label {
      font-weight: 700;
    }

    .el-table .ui-warning-row {
      background: #ddd !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-table td {
      padding: 3px 0 !important;
    }

    .el-dialog__body {
      //max-height: 500px;
      overflow-y: auto;
    }
  }

  ::v-deep.footer {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin: 10px 0;
    padding-bottom: 15px;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .entrust-form {
    ::v-deep {
      .el-form-item {
        margin-bottom: 0px !important;
      }
    }
  }
</style>
